import { render } from "./login.vue?vue&type=template&id=0be00c55"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=0be00c55&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__